// extracted by mini-css-extract-plugin
export default {"paper":"RightDrawer_paper__71yaa","closeIconWrapper":"RightDrawer_closeIconWrapper__EJ1et","closeIcon":"RightDrawer_closeIcon__EpbTd","inner":"RightDrawer_inner__bT2oU"};